import React from "react";

const MessageDetailsModal = ({
  selectedMessage,
  onClose,
  liveAvatars = {},
  memberAvatarMap = {},
  onStudyAction,
  redeeming = false,
}) => {
  if (!selectedMessage) return null;

  const senderName =
    `${selectedMessage?.sender?.firstName || ""} ${selectedMessage?.sender?.lastName || ""}`.trim() ||
    "Member";
  const avatarUrl =
    liveAvatars[String(selectedMessage?.sender?._id)] ||
    memberAvatarMap[String(selectedMessage?.sender?._id)] ||
    selectedMessage?.sender?.avatar ||
    `https://api.dicebear.com/6.x/initials/svg?seed=${encodeURIComponent(senderName)}`;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl p-6 w-full max-w-sm shadow-2xl relative animate-in zoom-in-95 border border-gray-100">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 w-8 h-8 flex items-center justify-center rounded-full bg-gray-50 hover:bg-gray-100"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>

        <div className="flex flex-col items-center mt-2 text-center">
          <img
            src={avatarUrl}
            alt="avatar"
            className="w-20 h-20 rounded-full border-4 border-white shadow-md mb-3 object-cover bg-gray-100"
          />
          <h4 className="text-lg font-bold text-gray-900">{senderName}</h4>
          <p className="text-xs text-gray-400 mb-5">
            Sent {new Date(selectedMessage.createdAt).toLocaleString()}
          </p>

          {selectedMessage.type === "reviewer_code" ? (
            <div className="w-full">
              <div className="p-4 rounded-2xl bg-blue-50 border border-blue-100 mb-5">
                <p className="text-[11px] font-bold uppercase tracking-wider text-blue-600 mb-1">
                  Shared Reviewer
                </p>
                <p className="text-base font-bold text-blue-900">
                  {selectedMessage.reviewer?.topic ||
                    selectedMessage.text?.replace("Shared Reviewer: ", "")}
                </p>
              </div>
              <button
                type="button"
                onClick={() => {
                  onClose();
                  onStudyAction(
                    selectedMessage.reviewerCode,
                    selectedMessage.reviewer?._id,
                    "summary"
                  );
                }}
                disabled={redeeming}
                className="w-full py-3 rounded-xl font-bold text-sm text-white bg-blue-600 hover:bg-blue-700 transition shadow-sm"
              >
                {redeeming ? "Opening..." : "Open Reviewer"}
              </button>
            </div>
          ) : (
            <div className="w-full bg-gray-50 p-4 rounded-2xl text-gray-800 text-sm border border-gray-100 text-left">
              {selectedMessage.text}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageDetailsModal;
